import { ResolverTag } from '@ps/web-core-enums';
import type { TranslationTag } from '@ps/web-core-intl';
import type { Error, Validator } from '@ps/web-shared-validators';
import { format } from 'date-fns';
import type { Required } from 'utility-types';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import { request as apiRequest } from '@swf/core/api/request';
import type { RequestOptions } from '@swf/core/types/Request';

const getDate = (date: string): Date => {
  const year = Number(date.substring(0, 4)),
    month = Number(date.substring(4, 6)),
    day = Number(date.substring(6, 8));

  return new Date(year, month - 1, day);
};

export const checkSelfExclusionDK = (
  options: Required<Partial<RequestOptions>, 'meta'>,
  messageDefault: TranslationTag,
  messageDate: TranslationTag,
  messageInfo: TranslationTag
) => {
  const checkSelfExclusionDK: Validator = async (value: string): Promise<Error> => {
    if (value && value.length === 10) {
      const {
        body: { isSelfExcluded, timeUntilExpire }
      } = await apiRequest({
        ...options,
        service: 'wc3.user.verify.cpr',
        body: { fiscalCode: value }
      });
      if (isSelfExcluded && timeUntilExpire) {
        return {
          valid: false,
          message: [
            messageDefault,
            {
              ...messageDate,
              values: { 0: format(getDate(timeUntilExpire), 'dd MMM yyyy') }
            },
            {
              ...messageInfo,
              values: {
                a: (msg: React.ReactNode) => (
                  <ResolverLink resolverTag={ResolverTag.HelpCenter}>{msg}</ResolverLink>
                )
              }
            }
          ]
        };
      }
      return {
        valid: true
      };
    }
    return {
      valid: false
    };
  };

  return checkSelfExclusionDK as Validator;
};
